<template>
    <div class="personal-center-comp"  v-bind:style="{'min-height': myHeight}">
        <div class="wrap">
            <reset-user-pwd></reset-user-pwd>
            <signature-qrcode></signature-qrcode>
            <div class="user-shot">
                <div class="edit-wrap">
                    <div class="member-shot">
                        <img v-if="userShot" class="shot" :src="userShot" alt="">
                        <img v-else class="shot" src="@/assets/img/shot.svg" alt="">
                    </div>
                    <file-upload
                        v-if="isBizVerified === 'NORMAL'"
                        class="edit"
                        post-action="/upload/post"
                        :size="1024 * 5"
                        :maximum="1"
                        :multiple="true"
                        :drop="true"
                        :drop-directory="true"
                        v-model="files"
                        @input-file="inputFile"
                        @input-filter="inputFilter"
                        ref="upload">
                            <img src="@/assets/img/icon/shot_edit_black.svg" alt="" srcset="">
                    </file-upload>
                </div>
                <div v-if="isAllGroup  || isBizVerified != 'NORMAL'" class="user-name">
                    <div class="name">
                        {{userName}} 
                    </div>
                </div>
                <div v-else class="user-name">
                    <div class="name">
                        {{userName}} /   
                    </div>
                    <div class="group">
                        {{userGroupName}}
                    </div>
                </div>
            </div>
            <div class="user-info-wrap">
                <div class="list">
                    <span class="title">帳號：</span>
                    <span class="content">{{personalInfo?personalInfo.account:'-'}}</span>
                </div>
                <div class="list">
                    <span class="title">電話：</span>
                    <span class="content">{{personalInfo?personalInfo.phoneNumber:'-'}}</span>
                </div>
                <!-- <div class="list">
                    <span class="title">企業名稱：</span>
                    <span class="content">{{personalInfo?personalInfo.companyName:'-'}}</span>
                </div>
                <div class="list">
                    <span class="title">業務分群：</span>
                    <span class="content">{{personalInfo?personalInfo.group:'-'}}</span>
                </div> -->
                <div class="list">
                    <span class="title">職務部門：</span>
                    <span class="content">{{personalInfo?personalInfo.role:'-'}}</span>
                </div>
                <div class="list">
                    <span class="title">登入密碼：</span>
                    <span class="content reset border-button" @click="resetPwd">修改密碼</span>
                </div>
            </div>
            <div class="personal-center-comp-hr"></div>
            <div class="signed-info-wrap">
                <h1>簽名設定</h1>
                <div class="description">
                    <!-- <img src="@/assets/img/icon/info_gray.svg" alt=""> -->
                    此簽名可以在簽約時自動帶入合約，您可以直接在此網頁進行簽名或掃描 QRcode 進行手機簽名
                </div>
                <div class="list">
                    <span class="title">直接簽名：</span>
                    <span class="content">
                        <sign-board :isSign="false" :isTitle="false" type="SETTING"></sign-board>
                    </span>
                </div>
                <div class="list">
                    <span class="title">手機簽名：</span>
                    <span class="content open-qrcode border-button" @click="openQrcode">掃碼簽名</span>
                </div>
                <div class="list">
                    <span class="title">是否在下次簽約時帶入合約：</span>
                    <span class="content">
                        {{isSignedToContract?'是':'否'}}
                        <rent-switch v-model="isSignedToContract" :dValue="isSignedToContract"></rent-switch>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FileUpload from 'vue-upload-component';
import resetUserPwd from '@/components/bussiness/widges/modals/resetUserPwd.vue';
import signatureQrcode from '@/components/bussiness/widges/modals/signatureQrcode.vue';
import signBoard from '@/components/bussiness/mgtCategory/bookingMgt/bizContract/signBoard';
import RentSwitch from '@/components/widge/RentSwitch.vue';
import { mapGetters } from 'vuex'

import { 
    baseWebUrl,
    baseDomain,
    apiBizAutoSignSetting,
    apiBizGetPersonalInfo
} from "@/apis/api.js"; 

export default {
    data () {
        return{
            files: [],
            myHeight: window.innerHeight + 'px',
            isSignedToContract: false,
        }
    },
    mounted () {
        this.$store.dispatch('getBizPersonalInfo')
    },
    watch: {
        files: {
            handler: function (val) {
                this.$store.dispatch('setBizUserShot', val)
            },
            deep: true
        },
        autoSign: {
            handler: function (val) {
                this.isSignedToContract = val
            },
            immediate: true
        },
        isSignedToContract: function (val) {
            this.setBizAutoSignSetting(val)
        },

    },
    methods: {
        resetPwd: function () {
            if(this.isBizVerified === 'NORMAL'){
                this.$store.dispatch('setModalStatus', {state: true, type: 'resetUserPwd'})
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
        },
        openQrcode: function () {
            this.$store.dispatch('setModalStatus', {state: true, type: 'signatureQrcode'})
        },
        inputFile: function (newFile, oldFile) {
            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                if (newFile.xhr) {
                //  Get the response status code
                // console.log('status', newFile.xhr.status)
                }
            }
        },
        inputFilter: function (newFile, oldFile, prevent) {
                console.log('response', newFile)
        
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpe|jpg|png)$/i.test(newFile.name)) {
                    this.alart.fail = true
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '請上傳PDF、JPG或PNG檔案',type: 'error'})
                    return prevent()
                }

                if(newFile.size > (1024*1024*5)){
                    this.alart.fail = true
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '檔案最大限制5MB',type: 'error'})
                    return prevent()
                }
            }
            // console.log(newFile)
            // Create a blob field
            newFile.blob = ''
            let URL = window.URL || window.webkitURL
            if (URL && URL.createObjectURL) {
                newFile.blob = URL.createObjectURL(newFile.file)
            }
        },
        setUserShot: function (files) {
            let formData = new FormData();
            console.log(files)
            formData.append('file', files[0].file);

            apiSetUserShot(formData)
            .then( res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    this.$store.dispatch('getBizPersonalInfo')
                    // this.getPersonalInfo()
                }
            })
        },
        getPersonalInfo: function () {
            apiBizGetPersonalInfo()
            .then( res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    this.personalInfo = res.data.result
                    // this.$store.dispatch('getUserStatus')
                }
            })
        },
        setBizAutoSignSetting: function (val) {
            var data = {
                "autoSign": val
            }
            apiBizAutoSignSetting(data)
            .then( res => {
                console.log(res)
                if(res.data.status == 'SUCCESS'){
                    this.$store.dispatch('bizGetUserInfo')
                }
            })
        },
        
    },
    computed: {
        userShot: function () {
            if( this.files.length > 0){
                return this.files[0].blob
            }else if( this.personalInfo && this.personalInfo.filePath ){
                return baseDomain+this.personalInfo.filePath
            } 
        },
        hostUrl: function () {
            return baseWebUrl + 'bizPhoneSigned?account='+this.userAccount+'&code='+this.signCode
        },
        ...mapGetters({
            isAllGroup: 'GET_BIZ_IS_ALL_GROUP',
            userGroupName: 'GET_BIZ_GROUP_NAME',
            userName: 'GET_BIZ_USER_NAME',
            isBizVerified: 'GET_BIZ_COMPANY_IS_VERIFIED',
            personalInfo: 'BIZ_GET_PERSONAL_INFO',
            autoSign: 'GET_BIZ_USER_AUTO_SIGN'
        })
    },
    components: {
        FileUpload,
        resetUserPwd,
        signBoard,
        signatureQrcode,
        RentSwitch,
    }
}
</script>
<style lang="scss">
    .personal-center-comp{
        .personal-center-comp-hr{
            width: 100%;
            height: 1px;
            background: #f3f3f3;
            margin: 30px 0;
        }
        >.wrap{
            box-shadow: 1px 0 10px 0 rgba(41, 38, 37, 0.02);
            border: solid 1px #f3f3f3;
            background-color: #ffffff;
            padding: 24px;
            border-radius: 6px;
            box-sizing: border-box;
            .user-shot{
                display: flex;
                align-items: center;
                margin-bottom: 27px;
                .edit-wrap{
                    position: relative;
                    width: 80px;
                    margin-right: 16px;
                    .member-shot{
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-right: 26px;
                        box-shadow: 0px 2px 4px rgba(165, 166, 187, 0.2);
                        width: 80px;
                        height: 80px;
                        overflow: hidden;
                        border-radius: 50%;
                        .shot{
                            width: 80px;
                        }
                    }
                    .edit{
                        position: absolute;
                        right: 0px;
                        bottom: 0px;
                        >label{
                            cursor: pointer;
                        }
                    }
                }
                .user-name{
                    display: flex;
                    align-items: center;
                    font-size: 20px;
                    font-weight: 500;
                    .name{
                        color: #a19d9c;
                        margin-right: 6px;
                    }
                }
            }
            .user-info-wrap{
                .list{
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                    .title{
                        width: 70px;
                        color: #a19d9c;
                        margin-right: 4px;
                        display: inline-flex;
                    }
                    .content{
                        display: flex;
                        &.reset{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 96px;
                            height: 36px;
                            cursor: pointer;
                        }
                    }
                }
                
            }
            .signed-info-wrap{
                h1{
                    font-size: 24px;
                    margin-bottom: 16px;
                }
                .description{
                    display: flex;
                    align-items: center;
                    color: #676362;
                    margin-bottom: 28px;
                    img{
                        margin-right: 5px;
                    }
                }
                .list{
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                    .title{
                        color: #a19d9c;
                        margin-right: 4px;
                        display: inline-flex;
                    }
                    .content{
                        display: flex;
                        align-items: center;
                        &.open-qrcode{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            width: 96px;
                            height: 36px;
                            cursor: pointer;
                        }
                        .sign-canvas{
                            border-radius: 6px;
                            border: solid 1px #e0dfde;
                            // margin-right: 12px;
                            width: 100px;
                            height: 100px;
                            background: #f6f6f6;
                            width: 400px;
                            height: 200px;
                        }
                    }
                }
                .rent-switch{
                    margin-left: 4px;
                    .rent-switch-item{
                        width: 40px;
                        height: 22px;
                        border-radius: 14px;
                        backdrop-filter: blur(6.7px);
                        box-shadow: 0 3px 13px 0 rgba(37, 38, 94, 0.1);
                        &::before{
                            top: 0;
                            left: 0px;
                            width: 40px;
                            height: 23px;
                        }
                        &::after{
                            top: 3px;
                            left: 3px;
                            width: 17px;
                            height: 17px;
                        }
                        &.rent-switch-on{
                            &::after{
                                left: 0px;
                            }
                        }
                    }
                }
            }
        }
        
        
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/personalCenter/personalCenter/personalCenterComp.vue